import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,  Select as MaterialSelect  ,Box ,TextField,
  LinearProgress, Tooltip, Typography} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
 
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalInformativo';
import Mapa from './Mapa';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
     tablaContainer: {
      width: '30.5rem',
      maxHeight: '24rem',
      minHeight: 280,
      //minWidth:'100%',
    },
       tituloEstilo:{
      paddingBottom:'.25rem',
      fontWeight:'bold'
    },
       tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      } 
    },
    hover: {},
    selected: {},
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const ModalDetalle = ({modalAbierto, setModalAbierto, titulo,  registro }) => {
  let history = useHistory();
  const classes = useStyles();
  const auxCol=process.env.REACT_APP_Fondo_Color  
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [listAllMaquinas, setListAllMaquinas] = useState([]); 
  const [listOriginal, setListOriginal] = useState([]); 
 
  React.useEffect(()=>{     
 
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

   
  const leyenda=()=>{
    let cadena =""
    if (registro.Dir) {
      cadena="Dirección: "+ registro.Dir
    }
    return cadena
  }

  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={()=>{}}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} maxTam={true}
    setEspera={setEspera}  tamanio={"lg"} btnDesact={btnDesact}
  >
    {registro.Lat!==0?
     <Box display={"flex"} flexDirection={"column"} mb={2} style={{minWidth:"10rem", height:"20rem"}}>
      <Typography>{leyenda()}</Typography>
      <Mapa registro={registro} />
    </Box>            
    :<Box display={"flex"} flexDirection={"column"} mb={2} style={{minWidth:"20rem", height:"2rem"}}>
      <Typography>Sin coordenadas</Typography>      
    </Box>
    }
  </Modal>
  );
}
 
export default ModalDetalle;